import React, { FC } from "react";
import { Button } from "components/shared";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "./DeleteWindow.module.sass";

interface DeleteWindowProps {
	subtitle: string;
	onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
	close: () => void;
}

export const DeleteWindow: FC<DeleteWindowProps> = ({ subtitle, onSubmit, close }) => {
	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>Вы уверены?</h4>
			<span className={styles.subtitle}>{subtitle}</span>
			<form onSubmit={onSubmit} className={styles.form}>
				<div className={styles.btns}>
					<Button onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED} className={styles.button}>
						Отмена
					</Button>
					<Button color={BUTTON_COLORS.ERROR} type="submit" className={styles.button}>
						Архивировать
					</Button>
				</div>
			</form>
		</section>
	);
};
